import React from 'react'
import PropTypes from 'prop-types'
import Typography from 'material-ui/Typography'

const Subtitle = ({children, ...props}) => (
  <Typography {...props} variant={'body1'} align={'center'}>{children}</Typography>
)

Subtitle.propTypes = {
  children: PropTypes.string.isRequired,
}

export default Subtitle



// WEBPACK FOOTER //
// ./src/sections/flow/components/subtitle.jsx